import script from "./PageEmployees.vue?vue&type=script&setup=true&lang=js"
export * from "./PageEmployees.vue?vue&type=script&setup=true&lang=js"

import "./PageEmployees.vue?vue&type=style&index=0&id=ed173396&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ed173396"]])

export default __exports__